import React from 'react';
import PropTypes from 'prop-types';
import Mosvita from '../../ui/typography/mosvita';
import {
  CardContainer,
  CardImage,
  CardDetails,
  CardTitle,
  CardBody
} from './style';
import { HtmlRaw } from '../../components';

const CourseOnlineCard = ({ card }) => {
  const { title, body, url } = card;
  return (
    <CardContainer>
      <CardImage src={url} />
      <CardDetails>
        <CardTitle>
          <Mosvita type="courseOnlineCardTitle">{title}</Mosvita>
        </CardTitle>
        <CardBody>
          <Mosvita type="courseOnlineCardBody">
            <HtmlRaw html={body} />
          </Mosvita>
        </CardBody>
      </CardDetails>
    </CardContainer>
  );
};

CourseOnlineCard.propTypes = {
  card: PropTypes.object.isRequired
};

export default CourseOnlineCard;
